module.exports = __webpack_public_path__ + "img/4.9dad8d05.jpg";